<section class="popup-page">
  <header>
    <button type="button" class="icon-button" (click)="back()" [attr.aria-label]="'PROFILE_POPUP_BACK' | translate">&#8249;</button>
    <div class="title">
      <span class="user-name">{{ userName }}</span>
      <h2>{{ 'PROFILE_POPUP_CONFIRM_ACCESS' | translate }}</h2>
    </div>
    <button type="button" class="icon-button" (click)="close()" [attr.aria-label]="'CLOSE' | translate">&#215;</button>
  </header>

  <div class="body">
    <div class="section-header">
      <h3>{{ 'PROFILE' | translate }}</h3>
      <button type="button" class="link-button" (click)="editProfile()">{{ 'EDIT' | translate }}</button>
    </div>
    <dl class="card">
      <div class="row-item">
        <dt>{{ 'NAME' | translate }}</dt>
        <dd [title]="userName">{{ userName }}</dd>
      </div>
      <div class="row-item">
        <dt>{{ 'EMAIL' | translate }}</dt>
        <dd [title]="email">{{ email || ('PROFILE_POPUP_NOT_SET' | translate) }}</dd>
      </div>
      <div class="row-item">
        <dt>{{ 'PHONE' | translate }}</dt>
        <dd>{{ phone || ('PROFILE_POPUP_NOT_SET' | translate) }}</dd>
      </div>
      <div class="row-item">
        <dt>{{ 'PROFILE_POPUP_NOTE' | translate }}</dt>
        <dd [title]="profileDetails?.notes || ''">{{ profileDetails?.notes || ('PROFILE_POPUP_NOT_SET' | translate) }}</dd>
      </div>
    </dl>

    <dl class="card">
      <div class="row-item">
        <dt>{{ 'USER_TYPE' | translate }}</dt>
        <dd>{{ userTypeKey ? (userTypeKey | translate) : ('PROFILE_POPUP_NOT_SET' | translate) }}</dd>
      </div>
    </dl>

    <div class="section-header">
      <h3>{{ 'PROFILE_POPUP_ACCESS' | translate }}</h3>
      <button *ngIf="reviewMode === 'units' && !sitewide" type="button" class="link-button" (click)="viewAll()" [disabled]="!units.length">{{ 'VIEW_ALL' | translate }}</button>
    </div>
    <div *ngIf="sitewide" class="sitewide-access">
      <span class="building-icon" aria-hidden="true"><img src="assets/svg/ico-building-gray.svg" alt="" /></span>
      <span class="sitewide-details"><strong>{{ siteName }}</strong><span>{{ 'ALL_ACCESS' | translate }}</span></span>
    </div>
    <div *ngIf="!sitewide" class="time-summary">
      <p>
        <mat-icon aria-hidden="true">calendar_today</mat-icon>
        <span>
          <strong>{{ timeSummary }}</strong>
          <strong *ngIf="daysSummary" class="days">{{ daysSummary }}</strong>
        </span>
      </p>
      <p *ngIf="timeZone">
        <img src="assets/svg/ico-vector-globe.svg" alt="" aria-hidden="true" />
        <strong>{{ timeZone }}</strong>
      </p>
    </div>

    <ul *ngIf="!sitewide && reviewMode === 'units'" class="unit-list">
      <li *ngFor="let unit of units" class="unit-card">
        <button
          type="button"
          class="unit-header"
          (click)="toggleUnit(unit)"
          [attr.aria-expanded]="isExpanded(unit)"
          [attr.aria-controls]="'confirm-unit-' + unit.unitId"
        >
          <span class="unit-icon" aria-hidden="true"><img src="assets/svg/ico-default-home.svg" alt="" /></span>
          <span class="unit-name" [title]="unit.label">{{ unit.label }}</span>
          <mat-icon aria-hidden="true">{{ isExpanded(unit) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
        <div *ngIf="isExpanded(unit)" class="unit-detail" [id]="'confirm-unit-' + unit.unitId">
          <img src="assets/svg/ico-building-gray.svg" alt="" aria-hidden="true" />
          <span class="unit-text">
            <span class="building-name" [title]="building?.buildingName">{{ building?.buildingName }}</span>
            <span class="unit-location">
              {{ unit.floorName }}<ng-container *ngIf="unit.wingName">, {{ unit.wingName }} {{ 'WING' | translate }}</ng-container>
            </span>
          </span>
        </div>
      </li>
    </ul>
    <div *ngIf="!sitewide && reviewMode === 'locks'" class="lock-access-summary">
      <div class="lock-unit-header">
        <span class="unit-icon" aria-hidden="true"><img src="assets/svg/ico-default-home.svg" alt="" /></span>
        <span class="unit-name" [title]="selectedUnits[0]?.label || ''">{{ selectedUnits[0]?.label }}</span>
        <span class="lock-count">{{ selectedLocks.length }}</span>
      </div>
      <ul class="lock-list">
        <li *ngFor="let lock of selectedLocks" class="lock-item">
          <img src="assets/svg/ico-lock-user-access.svg" alt="" aria-hidden="true" />
          <span class="unit-text">
            <span class="unit-name" [title]="lock.deviceName || ''">{{ lock.deviceName }}</span>
            <span class="unit-location" [title]="lockLocation">{{ lockLocation }}</span>
          </span>
        </li>
      </ul>
    </div>
  </div>

  <p *ngIf="inviteErrorKey" class="error" role="alert">{{ inviteErrorKey | translate }}</p>
  <button type="button" class="primary-button" (click)="confirm()" [disabled]="!canConfirm" [attr.aria-busy]="isSubmitting || isSendingInvite">
    {{ ((reviewMode === 'units' && (contactRequired || canRetryInvite)) ? 'PROFILE_POPUP_SEND_INVITE' : 'PROFILE_POPUP_CONFIRM_ACCESS') | translate }}
  </button>
</section>
